export default {
  DISCOUNT_BASE: 'דיסקונט בסיס',
  DISCOUNT: 'דיסקונט',
  DISCOUNT_API: 'דיסקונט ישיר',
};
